import ApiRequest from "../index"

const tariffsRequest = {
  get: async () => ApiRequest.get("/payhow/tariffs/show")
}

export default tariffsRequest
